import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_CaregiverScreening = ({
   itemsRef,
   showErrorFor,
}) => {

   return (
      <form id='ACTS_CaregiverScreening' className='file-pdf-document'>
         <div className='file-template'>


            <h3>
               Child and Adolescent Trauma Screen (CATS) - Caregiver Report (Ages 7-17 years)
            </h3>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Child's Name:</span>
                     <input type="text" id="txtChildName" name="txtChildName" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Date:</span>
                     <input type='date' id="txtDate" name="txtDate" className='add-only' />
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Caregiver Name:</span>
                     <input type="text" id="txtCaregiverName" name="txtCaregiverName" className='add-only' />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Stressful or scary events happen to many children. Below is a list of stressful and scary events that sometimes happen. Mark YES if it happened to the child to the best of your knowledge. Mark No if it didn't happen to the child.</b>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>1. Serious natural disaster like a flood, tornado, hurricane, earthquake, or fire.</span>
               <input type="radio" id="rbSerious1_Yes" name="rbSerious1" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious1_No" name="rbSerious1" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>2. Serious accident or injury like a car/bike crash, dog bite, sports injury.</span>
               <input type="radio" id="rbSerious2_Yes" name="rbSerious2" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious2_No" name="rbSerious2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>3. Robbed by threat, force or weapon.</span>
               <input type="radio" id="rbSerious3_Yes" name="rbSerious3" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious3_No" name="rbSerious3" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>4. Slapped, punched, or beat up in the family.</span>
               <input type="radio" id="rbSerious4_Yes" name="rbSerious4" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious4_No" name="rbSerious4" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>5. Slapped, punched, or beat up by someone not in the family.</span>
               <input type="radio" id="rbSerious5_Yes" name="rbSerious5" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious5_No" name="rbSerious5" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>6. Seeing someone in the family get slapped, punched or beat up.</span>
               <input type="radio" id="rbSerious6_Yes" name="rbSerious6" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious6_No" name="rbSerious6" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>7. Seeing someone in the community get slapped, punched or beat up.</span>
               <input type="radio" id="rbSerious7_Yes" name="rbSerious7" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious7_No" name="rbSerious7" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>8. Someone older touching his/her private parts when they shouldn't.</span>
               <input type="radio" id="rbSerious8_Yes" name="rbSerious8" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious8_No" name="rbSerious8" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>9. Someone forcing or pressuring sex, or when s/he couldn't say no.</span>
               <input type="radio" id="rbSerious9_Yes" name="rbSerious9" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious9_No" name="rbSerious9" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>10. Someone close to the child dying suddenly or violently.</span>
               <input type="radio" id="rbSerious10_Yes" name="rbSerious10" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious10_No" name="rbSerious10" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>11. Attacked, stabbed, shot at or hurt badly.</span>
               <input type="radio" id="rbSerious11_Yes" name="rbSerious11" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious11_No" name="rbSerious11" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>12. Seeing someone attacked, stabbed, shot at, hurt badly or killed.</span>
               <input type="radio" id="rbSerious12_Yes" name="rbSerious12" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious12_No" name="rbSerious12" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>13. Stressful or scary medical procedure.</span>
               <input type="radio" id="rbSerious13_Yes" name="rbSerious13" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious13_No" name="rbSerious13" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>14. Being around war.</span>
               <input type="radio" id="rbSerious14_Yes" name="rbSerious14" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious14_No" name="rbSerious14" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>15. Other stressful or scary event?</span>
               <input type="radio" id="rbSerious15_Yes" name="rbSerious15" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbSerious15_No" name="rbSerious15" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Describe:</span>
               <textarea id="txtDescribe" name="txtDescribe" className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <b>Which one is bothering the child most now?</b>
               <input type="text" id="txtBothering" name="txtBothering" className='add-only' />
            </p>
            <p className='w-750'>
               <b>If you marked "YES" to any stressful or scary events for the child, then turn the page and answer the next questions.</b>
            </p>
            <p className='w-750'>
               <b>Mark 0, 1, 2 or 3 for how often the following things have bothered the child in the last two weeks:</b>
            </p>
            <p className='w-750'>
               <b>0 Never / 1 Once in a while / 2 Half the time / 3 Almost always</b>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>1. Upsetting thoughts or images about a stressful event. Or re-enacting a stressfulevent
                        in play.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting1_Yes" name="rbUpsetting1" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting1_No" name="rbUpsetting1" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting1_Yse" name="rbUpsetting1" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting1_Ye" name="rbUpsetting1" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>2. Bad dreams related to a stressful event.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting2_Yes" name="rbUpsetting2" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting2_No" name="rbUpsetting2" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting2_Yse" name="rbUpsetting2" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting2_Ye" name="rbUpsetting2" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>3. Acting, playing or feeling as if a stressful event is happening rightnow.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting3_Yes" name="rbUpsetting3" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting3_No" name="rbUpsetting3" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting3_Yse" name="rbUpsetting3" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting3_Ye" name="rbUpsetting3" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>4. Feeling very emotionally upset when reminded of a stressful event.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting4_Yes" name="rbUpsetting4" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting4_No" name="rbUpsetting4" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting4_Yse" name="rbUpsetting4" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting4_Ye" name="rbUpsetting4" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>5. Strong physical reactions when reminded of a stressful event </span><span className='small'>(sweating, heart beating fast).</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting5_Yes" name="rbUpsetting5" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting5_No" name="rbUpsetting5" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting5_Yse" name="rbUpsetting5" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting5_Ye" name="rbUpsetting5" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>6. Trying not to remember, talk about or have feelings about a stressfulevent.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting6_Yes" name="rbUpsetting6" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting6_No" name="rbUpsetting6" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting6_Yse" name="rbUpsetting6" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting6_Ye" name="rbUpsetting6" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>7. Avoiding activities, people, places or things that are reminders of a stressfulevent.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting7_Yes" name="rbUpsetting7" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting7_No" name="rbUpsetting7" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting7_Yse" name="rbUpsetting7" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting7_Ye" name="rbUpsetting7" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>8. Not being able to remember an important part of a stressfulevent.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting8_Yes" name="rbUpsetting8" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting8_No" name="rbUpsetting8" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting8_Yse" name="rbUpsetting8" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting8_Ye" name="rbUpsetting8" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>9. Negative changes in how s/he thinks about self, others or the world after a stressful event.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting9_Yes" name="rbUpsetting9" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting9_No" name="rbUpsetting9" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting9_Yse" name="rbUpsetting9" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting9_Ye" name="rbUpsetting9" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>10. Thinking a stressful event happened because s/he or someone else did something wrong or did not do enough to stop it.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting10_Yes" name="rbUpsetting10" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting10_No" name="rbUpsetting10" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting10_Yse" name="rbUpsetting10" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting10_Ye" name="rbUpsetting10" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>11. Having very negative emotional states </span><span className='small'>(afraid, angry, guilty,ashamed).</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting11_Yes" name="rbUpsetting11" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting11_No" name="rbUpsetting11" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting11_Yse" name="rbUpsetting11" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting11_Ye" name="rbUpsetting11" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>12. Losing interest in activities s/he enjoyed before a stressful event. Including not playing as much.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting12_Yes" name="rbUpsetting12" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting12_No" name="rbUpsetting12" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting12_Yse" name="rbUpsetting12" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting12_Ye" name="rbUpsetting12" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>13. Feeling distant or cut off from people around her/him.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting13_Yes" name="rbUpsetting13" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting13_No" name="rbUpsetting13" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting13_Yse" name="rbUpsetting13" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting13_Ye" name="rbUpsetting13" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>14. Not showing or reduced positive feelings </span><span className='small'>(being happy, having lovingfeelings).</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting14_Yes" name="rbUpsetting14" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting14_No" name="rbUpsetting14" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting14_Yse" name="rbUpsetting14" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting14_Ye" name="rbUpsetting14" className='add-only' value="2" /> 3
                  </td>
               </tr><tr>
                  <td className='w-750'>
                     <span className='eleHeader'>15. Being irritable. Or having angry outbursts without a good reason and taking it out</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting15_Yes" name="rbUpsetting15" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting15_No" name="rbUpsetting15" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting15_Yse" name="rbUpsetting15" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting15_Ye" name="rbUpsetting15" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>16. Risky behavior or behavior that couldbe harmful.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting16_Yes" name="rbUpsetting16" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting16_No" name="rbUpsetting16" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting16_Yse" name="rbUpsetting16" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting16_Ye" name="rbUpsetting16" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>17. Being overly alert or on guard.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting17_Yes" name="rbUpsetting17" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting17_No" name="rbUpsetting17" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting17_Yse" name="rbUpsetting17" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting17_Ye" name="rbUpsetting17" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>18. Being jumpy or easily startled.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting18_Yes" name="rbUpsetting18" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting18_No" name="rbUpsetting18" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting18_Yse" name="rbUpsetting18" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting18_Ye" name="rbUpsetting18" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>19. Problems with concentration.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting19_Yes" name="rbUpsetting19" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting19_No" name="rbUpsetting19" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting19_Yse" name="rbUpsetting19" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting19_Ye" name="rbUpsetting19" className='add-only' value="2" /> 3
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>20. Trouble falling or staying asleep.</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting20_Yes" name="rbUpsetting20" className='add-only' value="0" /> 0
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting20_No" name="rbUpsetting20" className='add-only' value="1" /> 1
                  </td>
                  <td className='w-200'>
                     <input type="radio" id="rbUpsetting20_Yse" name="rbUpsetting20" className='add-only' value="2" /> 2
                  </td>
                  <td className='w-150'>
                     <input type="radio" id="rbUpsetting20_Ye" name="rbUpsetting20" className='add-only' value="2" /> 3
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-250'><b>CATS 7-17 Years Score </b>
                  </td>
                  <td className='w-250'><b>CATS 7-17 Years Score 15-20</b>
                  </td>
                  <td className='w-250'><b>CATS 7-17 Years Score 21+</b>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'><b>Normal. Not clinically elevated.</b>
                  </td>
                  <td className='w-250'><b>Moderate trauma-related distress.</b>
                  </td>
                  <td className='w-250'><b>Probable PTSD.</b>
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <b>Please mark "YES" or "NO" if the problems you marked interfered with:</b>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>1. Getting along with others</span>
               <input type="radio" id="rbGetting1_Yes" name="rbGetting1" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbGetting1_No" name="rbGetting1" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>2. Hobbies/Fun</span>
               <input type="radio" id="rbGetting2_Yes" name="rbGetting2" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbGetting2_No" name="rbGetting2" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>3. School or work</span>
               <input type="radio" id="rbGetting3_Yes" name="rbGetting3" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbGetting3_No" name="rbGetting3" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>4. Family relationships</span>
               <input type="radio" id="rbGetting4_Yes" name="rbGetting4" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbGetting4_No" name="rbGetting4" className='add-only' value="0" /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>5. General happiness</span>
               <input type="radio" id="rbGetting5_Yes" name="rbGetting5" className='add-only' value="1" /> Yes &nbsp;
               <input type="radio" id="rbGetting5_No" name="rbGetting5" className='add-only' value="0" /> No
            </p>


         </div>
      </form>

   )
}  
